var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('video',{attrs:{"playsinline":"","autoplay":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.videoPath,"type":"video/mp4","poster":"./assets/videoThumbnail.png"}})]),_c('v-img',{attrs:{"id":"top_logo","src":require('../assets/NUMAZU_DISTILLERY_square_white.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }